import { assessmentConfig } from '../config/site';
import { validateAssessmentAnswers } from './assessmentSchema.mjs';
import { findings, areaQuestions } from '../config/report';
import { getHealthReport, getFitSummary, getAnnualTimeCost } from './assessment';

export function buildReport(answers) {
  const base = getHealthReport(answers);
  const fit = getFitSummary(answers, base.score);
  const areas = base.areas.map(area => {
    const index = assessmentConfig.questions.find(q => q.id === areaQuestions[area.key]).options.indexOf(answers[areaQuestions[area.key]]);
    const [short, long] = findings[area.key][Math.max(index, 0)];
    return { ...area, short, long };
  });
  const tie = ['errorExposure','calculation','visibility','dataCapture'];
  const topRisks = [...areas].sort((a,b) => a.score-b.score || tie.indexOf(a.key)-tie.indexOf(b.key)).slice(0,3);
  return {...base, areas, topRisks, ...fit, annualCost: getAnnualTimeCost(answers)};
}
export const money = value => new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',maximumFractionDigits:0}).format(value);
export function validateAnswers(answers, questions = assessmentConfig.questions) {
  return validateAssessmentAnswers(answers, questions);
}